import FeaturesTablet from "./FeaturesTablet";

export default FeaturesTablet;
export { FeaturesTablet };
